var map = {
	"./CanvasClear": 77,
	"./CanvasClear.js": 77,
	"./CommandAbstract": 27,
	"./CommandAbstract.js": 27,
	"./ComponentDelete": 78,
	"./ComponentDelete.js": 78,
	"./ComponentEnter": 79,
	"./ComponentEnter.js": 79,
	"./ComponentExit": 80,
	"./ComponentExit.js": 80,
	"./ComponentNext": 81,
	"./ComponentNext.js": 81,
	"./ComponentPrev": 82,
	"./ComponentPrev.js": 82,
	"./ComponentStyleClear": 83,
	"./ComponentStyleClear.js": 83,
	"./CopyComponent": 84,
	"./CopyComponent.js": 84,
	"./CreateComponent": 12,
	"./CreateComponent.js": 12,
	"./DeleteComponent": 29,
	"./DeleteComponent.js": 29,
	"./Drag": 44,
	"./Drag.js": 44,
	"./ExportTemplate": 28,
	"./ExportTemplate.js": 28,
	"./Fullscreen": 41,
	"./Fullscreen.js": 41,
	"./ImageComponent": 30,
	"./ImageComponent.js": 30,
	"./InsertCustom": 20,
	"./InsertCustom.js": 20,
	"./MoveComponent": 31,
	"./MoveComponent.js": 31,
	"./OpenAssets": 38,
	"./OpenAssets.js": 38,
	"./OpenBlocks": 37,
	"./OpenBlocks.js": 37,
	"./OpenLayers": 34,
	"./OpenLayers.js": 34,
	"./OpenStyleManager": 35,
	"./OpenStyleManager.js": 35,
	"./OpenTraitManager": 36,
	"./OpenTraitManager.js": 36,
	"./PasteComponent": 85,
	"./PasteComponent.js": 85,
	"./Preview": 42,
	"./Preview.js": 42,
	"./Resize": 43,
	"./Resize.js": 43,
	"./SelectComponent": 11,
	"./SelectComponent.js": 11,
	"./SelectParent": 40,
	"./SelectParent.js": 40,
	"./SelectPosition": 19,
	"./SelectPosition.js": 19,
	"./ShowOffset": 39,
	"./ShowOffset.js": 39,
	"./SwitchVisibility": 33,
	"./SwitchVisibility.js": 33,
	"./TextComponent": 32,
	"./TextComponent.js": 32
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 227;